import { format } from 'date-fns';

import {
	ONE_HOUR_IN_SECONDS,
	ONE_MINUTE_IN_SECONDS,
	ZERO,
} from '@components/ModalComponents/ProfileUserForm/CodeForm/constants';

export const secondsToHHMMSS = (seconds: number): string => {
	const hours = Math.floor(seconds / ONE_HOUR_IN_SECONDS);
	const minutes = Math.floor((seconds % ONE_HOUR_IN_SECONDS) / ONE_MINUTE_IN_SECONDS);
	const remainingSeconds = seconds % ONE_MINUTE_IN_SECONDS;

	return format(
		new Date(ZERO, ZERO, ZERO, hours, minutes, remainingSeconds),
		'HH:mm:ss',
	);
};
